/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_Li4Inputs */

const en_guide_what_is_json_s6_li4 = /** @type {(inputs: Guide_What_Is_Json_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep nesting levels <strong>reasonable</strong>: deeply nested JSON is hard to read and work with`)
};

const ko_guide_what_is_json_s6_li4 = /** @type {(inputs: Guide_What_Is_Json_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 수준을 <strong>적절하게</strong> 유지하세요: 깊이 중첩된 JSON은 읽고 작업하기 어렵습니다`)
};

const ja_guide_what_is_json_s6_li4 = /** @type {(inputs: Guide_What_Is_Json_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストの深さを<strong>適度</strong>に保ってください: 深すぎるネストは読みづらく、扱いにくくなります`)
};

/**
* | output |
* | --- |
* | "Keep nesting levels <strong>reasonable</strong>: deeply nested JSON is hard to read and work with" |
*
* @param {Guide_What_Is_Json_S6_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_li4 = /** @type {((inputs?: Guide_What_Is_Json_S6_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_li4(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_li4(inputs)
	return ja_guide_what_is_json_s6_li4(inputs)
});